import React, { FC, useContext, useMemo } from "react";
import { commonsStoreContext, ShowView } from "lego-gui-lib";
import { FieldSetsForm } from "lego-gui-lib/lib/components/Views/ShowView/FieldSetsForm";
import { SanContext, SANEditSchema } from "../schema";
import { observer } from "mobx-react-lite";

interface FormViewProps {
  id: {};
  groups: string[];
}

export const FormView: FC<FormViewProps> = observer(({ id, groups }) => {
  const SAN = useContext(SanContext);
  const commons = useContext(commonsStoreContext);
  const Schema = useMemo(() => SANEditSchema.pickGroups(...groups), [groups]);

  return (
    <ShowView
      preloadData={false}
      titleRow={false}
      Presentation={FieldSetsForm}
      commons={commons}
      fields={Schema}
      dataSource={SAN.oneDataSource}
      id={id}
    />
  );
});
